import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/sbw 1.png";
import background from "../assets/background.png";
import right from "../assets/Group 627089.svg";
import Button from "./Button";
import FeatherIcon from "feather-icons-react";

const ConfirmCreatePassword = () => {
  const location = useLocation();
  const history = useNavigate();

  return (
    <>
      <div
        className="min-h-screen"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="grid grid-cols-12">
          <div className="col-span-4 md:col-span-6 lg:col-span-7 xl:col-span-7 2xl:col-span-8"></div>
          <div className="min-h-screen p-8 top-[60px] col-span-8 md:col-span-6 lg:col-span-5 xl:col-span-5 2xl:col-span-4 bg-[#0d223d]/60 backdrop-blur-[80px] shadow-lg inline-flex">
            <div className="w-full flex-col justify-center items-center inline-flex">
              <>
                <img src={Logo} />
              </>
              <div className="w-full border-t border-[#b3b5bd] my-4"></div>
              <div className="flex flex-col items-center text-center space-y-8">
                <div className="bg-green-500 rounded-full flex items-center justify-center md:h-10 md:w-10 lg:h-12 lg:w-12 xl:h-14 xl:w-14 2xl:h-16 2xl:w-16">
                  <FeatherIcon
                    icon="check-circle"
                    className="text-white size-5 md:size-5 lg:size-6 xl:size-7 2xl:size-8"
                  />
                </div>
                <h6 className="text-[#f3f4f8] text-xs md:text-xs lg:text-sm xl:text-base 2xl:text-3xl font-normal font-Poppins">
                  {location.state === "/reset-password"
                    ? "Password has been successfully re-set, Log in and explore the features on the website."
                    : "Password has been created successfully, Log in and explore the features on the website."}
                </h6>

                <Button
                  type="submit"
                  onClick={() => history("/login")}
                  primary={true}
                >
                  Log in
                </Button>
              </div>
              {/* <button
                type="submit"
                className={
                  "mt-4 md:mt-4 lg:mt-6 xl:mt-8 2xl:mt-10 size-12 w-full text-[#F3F4F8] text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-3xl !text-white p-1 rounded-lg transition duration-300"
                }
                onClick={() => history("/signup")}
              >
                Back
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmCreatePassword;
